import { render } from "./CompetitionDetailsView.vue?vue&type=template&id=299c894a&scoped=true"
import script from "./CompetitionDetailsView.vue?vue&type=script&lang=js"
export * from "./CompetitionDetailsView.vue?vue&type=script&lang=js"

import "./CompetitionDetailsView.vue?vue&type=style&index=0&id=299c894a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-299c894a"]])

export default __exports__